import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const dischargeUsersEntitlementsSlice = getBulkActionSlice(
    'dischargeUsersEntitlementsResult',
);

export const selectDischargeUsersEntitlementsShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.dischargeUsersEntitlementsResult.shown;

export const selectDischargeUsersEntitlementsBulkUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.dischargeUsersEntitlementsResult.uuid;

export const selectDischargeUsersEntitlementsTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.dischargeUsersEntitlementsResult.backgroundTask;

export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = dischargeUsersEntitlementsSlice.actions;
